import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import CardTable from './CardTable';
import {
  PRODUCT_CARD_TABLE_COLLECTION_EDIT_SETTINGS,
  SECOND_PRODUCT_CARD_TABLE_COLLECTION_EDIT_SETTINGS,
  CURRENT_TEMPLATE_NAME,
} from '../../utils/const';
import { COST_CARD_TABLE_COLLECTION_EDIT_SETTINGS } from '../../utils/factories/costPriceOptions';
import Forecast from '../portfolio/Finance/Forecast';
import RevenueModelCard from './RevenueModelCard';
import Chart from '../portfolio/Finance/Chart';
import ProjectSalesCard from './ProjectedSalesCard';

export default function CostRevenueCard({
  editMode = false,
  className,
  card,
  locales,
  forecast,
  chart,
}) {
  const {
    title,
    inputs,
    forecasts,
    costName,
    fixedCost,
    period,
    costPerUnit,
    unitCost,
    unit,
    productName,
    costs,
    products,
    revenues,
    revenueModel,
    pricing,
    product,
    endUserPrice,
    portfolio,
    charts,
    projectSales,
  } = card;
  const [currentTab, setCurrentTab] = useState('inputs');
  const {
    portfolioTemplate: { collection, loaded },
  } = useSelector((state) => state);

  const {
    portfolioTemplate: { fetchPortfolioTemplates },
  } = useDispatch();

  useEffect(() => {
    fetchPortfolioTemplates();
  }, []);

  const getChartColors = () => {
    // eslint-disable-next-line no-unused-vars
    const [firstColor, secondColor, thirdColor, fourthColor] =
      collection[0].colorPalette[0];
    return [thirdColor, fourthColor];
  };

  return (
    <div className={classNames('bmc-page-fincard', className)}>
      {title && (
        <div className="items-center flex flex-row justify-center w-full mb-5">
          <img src="/images/rxbar.png" className="bmc-page-card-icon" alt="" />
          <div className="bmc-page-card-big-title">{title}</div>
        </div>
      )}
      <div className="bmc-page-fincard-body">
        {forecast && (
          <div className="bmc-page-fincard-header">
            <div
              className={classNames('bmc-page-fincard-header-tab', {
                'bmc-page-fincard-header-tab--active': currentTab === 'inputs',
              })}
              onClick={() => setCurrentTab('inputs')}
            >
              {inputs}
            </div>

            <div
              className={classNames('bmc-page-fincard-header-tab', {
                'bmc-page-fincard-header-tab--active':
                  currentTab === 'forecasts',
              })}
              onClick={() => setCurrentTab('forecasts')}
            >
              {forecasts}
            </div>

            <div
              className={classNames('bmc-page-fincard-header-tab', {
                'bmc-page-fincard-header-tab--active': currentTab === 'charts',
              })}
              onClick={() => setCurrentTab('charts')}
            >
              {charts}
            </div>
          </div>
        )}

        {currentTab === 'inputs' && (
          <div className="flex flex-col gap-4">
            <CardTable
              title={fixedCost}
              titles={[costName, fixedCost, period]}
              editMode={editMode}
              collection={costs}
              collectionEditSettings={COST_CARD_TABLE_COLLECTION_EDIT_SETTINGS}
              locales={locales}
            />

            <CardTable
              title={costPerUnit}
              titles={[productName, unitCost, unit]}
              editMode={editMode}
              collection={products}
              collectionEditSettings={
                PRODUCT_CARD_TABLE_COLLECTION_EDIT_SETTINGS
              }
              locales={locales}
            />

            <CardTable
              title={pricing}
              titles={[product, endUserPrice, unit]}
              editMode={editMode}
              collection={products}
              collectionEditSettings={
                SECOND_PRODUCT_CARD_TABLE_COLLECTION_EDIT_SETTINGS
              }
              locales={locales}
            />

            <RevenueModelCard
              revenues={revenues}
              title={revenueModel}
              editMode={editMode}
            />

            <ProjectSalesCard
              products={products}
              locales={locales}
              editMode={editMode}
              title={projectSales}
            />
          </div>
        )}

        {forecast && currentTab === 'forecasts' && (
          <div className="portfolio-finance">
            <Forecast
              locales={locales.portfolio}
              setTotalCashOut={(_) => _}
              setTotalCashIn={(_) => _}
              summaryMode
            />
          </div>
        )}

        {chart && currentTab === 'charts' && loaded && (
          <Chart
            locales={portfolio}
            templateName={CURRENT_TEMPLATE_NAME}
            firstChartColor={getChartColors()[0]}
            secondChartColor={getChartColors()[1]}
            borderCardColor={undefined}
          />
        )}
      </div>
    </div>
  );
}
